import { Box } from 'components/Material/Box'
import { getMimeTypeFromExtension } from './utils'
import { MdSaveAlt } from 'react-icons/md'
import { Card } from 'components/Material/Card'
import { CardMedia } from 'components/Material/CardMedia'
import { useEffect, useState } from 'react'
import { format } from 'date-fns'

export type FileExtension = 'pdf' | 'doc' | 'docx' | 'jpg' | 'png'
type DownloadBase64FileProps = {
  file: string
  extension: FileExtension
  name: string
}

type DimensionsImage = {
  width: number
  height: number
}

export const downloadBase64File = ({ file, extension, name }: DownloadBase64FileProps) => {
  const fileType = getMimeTypeFromExtension(extension)

  const byteCharacters = atob(file)
  const byteArrays = []
  for (let offset = 0; offset < byteCharacters.length; offset += 512) {
    const slice = byteCharacters.slice(offset, offset + 512)

    const byteNumbers = new Array(slice.length)
    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i)
    }

    const byteArray = new Uint8Array(byteNumbers)
    byteArrays.push(byteArray)
  }
  const blob = new Blob(byteArrays, { type: fileType })

  const url = window.URL.createObjectURL(blob)

  const a = document.createElement('a')
  a.style.display = 'none'
  a.href = url
  a.download = name

  document.body.appendChild(a)
  a.click()

  window.URL.revokeObjectURL(url)
}

export const renderDefaultIcon = (isMobile: boolean) => {
  return (
    <Box className="mt-[30vh] flex w-full justify-center">
      <MdSaveAlt className={`text-[150px] ${isMobile ? 'text-blue-bb' : 'text-white'}`} />
    </Box>
  )
}

const getBase64ImageDimensions = async (base64String: string): Promise<DimensionsImage> => {
  return new Promise((resolve, reject) => {
    const img = new Image()
    img.onload = function () {
      resolve({
        width: img.width,
        height: img.height
      })
    }
    img.onerror = function () {
      reject(new Error('Failed to load the image'))
    }

    img.src = 'data:image;base64,' + base64String
  })
}

const RenderImage = ({
  base64Data,
  type,
  isMobile
}: {
  base64Data: string
  type: string
  isMobile: boolean
}) => {
  const [dimensions, setDimensions] = useState<DimensionsImage | null>(null)
  const [error, setError] = useState(null)
  const maxCardHeight = '70vh'

  useEffect(() => {
    getBase64ImageDimensions(base64Data)
      .then((dimensions) => {
        setDimensions(dimensions)
      })
      .catch((error) => {
        setError(error)
      })
  }, [base64Data, isMobile])

  if (error || !base64Data) {
    console.error('Error:', error)
    return null
  }

  return (
    <Card
      sx={{
        width: 'auto',
        height: dimensions ? dimensions.height : 'auto',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        maxWidth: '100%',
        maxHeight: maxCardHeight,
        overflow: 'hidden',
        backgroundColor: 'transparent',
        boxShadow: 'none'
      }}
    >
      <CardMedia
        component="img"
        image={`data:image/${type};base64,${base64Data}`}
        alt=""
        sx={{
          maxWidth: '100%',
          maxHeight: maxCardHeight,
          height: dimensions ? dimensions.height : 'auto',
          objectFit: 'contain'
        }}
      />
    </Card>
  )
}
export default RenderImage

export const mountTextUserDate = (user: string, date: string) => {
  if (!date) return '-'
  const datetime = new Date(date)

  const formattedDate = format(datetime, 'dd/MM/yyyy')
  const formattedTime = format(datetime, 'HH:mm') + ' hs'
  const formattedDateTime = `${formattedDate} ${formattedTime}`

  return `Por ${user} em ${formattedDateTime}`
}
